/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradePreviewResponse } from './moduleUpgradePreviewResponse';

export type GenericApiResponseModuleUpgradePreviewResponseData = ModuleUpgradePreviewResponse | null;
